module.exports = __webpack_public_path__ + "img/39.1c6ac9af.jpg";